
import { defineComponent } from "vue";
import PickingJobs from "@components/pap/PickingJobs.vue";

export default defineComponent({
    name: "PickingJobsView",
    components: { PickingJobs },
});
